export default "<div style=\"height: 100%; width: 99.5%; position: absolute; margin: 0; padding: 0;\" #leasingMapViewNode></div>\r\n";